// src/authSession.js
import { LARAVEL_BASE } from './config';

let _user = null; // cache ในหน่วยความจำ

export function getUser() { return _user; }
export function setUser(u) { _user = u || null; }

// แปลง permission จาก JWT ให้เป็น Set (ทั้ง id และ name)
function buildPermSet(u) {
    const s = new Set();
    if (!u) return s;

    // roles
    if (Array.isArray(u.roles)) u.roles.forEach(r => s.add(String(r).toLowerCase()));

    // EmpPermission / PosPermission: อาจมาเป็น object {id: name}
    const addMap = (m) => {
        if (!m) return;
        // รับทั้ง array/object
        if (Array.isArray(m)) m.forEach(x => s.add(String(x).toLowerCase()));
        else Object.entries(m).forEach(([id, name]) => {
        s.add(String(id)); // id เป็นสตริง
        if (name) s.add(String(name).toLowerCase());
        });
    };
    addMap(u.EmpPermission);
    addMap(u.PosPermission);

    // กรณี isadmin ให้ถือว่ามีสิทธิ์ทั้งหมด
    if (u.isadmin === 1 || u.isadmin === '1' || (u.roles||[]).includes('admin')) {
        s.add('__admin__');
    }
    return s;
}

let _permSet = new Set();
export function syncPermsFromUser(u) { _permSet = buildPermSet(u); }

export function hasPerm(...need) {
    if (_permSet.has('__admin__')) return true; // admin ผ่านทุกอัน
    const lower = need.map(x => String(x).toLowerCase());
    return lower.every(x => _permSet.has(x));
}

// any=ผ่านถ้ามีอย่างน้อย 1, all=ต้องครบทั้งหมด
export function hasAnyPerm(list) {
    if (_permSet.has('__admin__')) return true;
    return list.some(p => _permSet.has(String(p).toLowerCase()));
}

export async function fetchUser() {
    const res = await fetch(`${LARAVEL_BASE}/auth/me`, { credentials: 'include' });
    if (!res.ok) return null;
    const json = await res.json();
    const u = json.user || json; // รองรับทั้ง 2 รูปแบบ
    setUser(u);
    syncPermsFromUser(u);
    return u;
}
